module.exports = __webpack_public_path__ + "static/media/programs_resourceroom_700.1523d188.jpg";